/**
 * @author Ariel
 * @description 培训中心管理
 * @Date 2020/5/26
 */
import React from "react";
import {connect} from "dva";
import {templateConfig, reduxTemplateCofig} from "./config";

import {framework_tool} from '../../../tool';

let {WizContainer, WizReduxTemplate} = framework_tool;


class TrainCenterManager extends WizContainer {
  componentName = 'trainCenterManager';

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(TrainCenterManager);
